import { useState, useCallback } from 'react';

const UseHiddenState = (initialHidden = true) => {
    const [isHidden, setIsHidden] = useState(initialHidden);

    const toggleHidden = useCallback(() => {
        setIsHidden(prev => !prev);
    }, []);

    const show = useCallback(() => {
        setIsHidden(false);
    }, []);

    const hide = useCallback(() => {
        setIsHidden(true);
    }, []);

    return {
        isHidden,
        toggleHidden,
        show,
        hide,
        isVisible: !isHidden
    };
};

export default UseHiddenState;